import { AdTargeting } from 'types/Slideshow';
import ProximityAd from 'components/Ad/ProximityAd';
import SectionHeader from 'components/Shared/SectionHeader';
import { colors } from 'components/styles/variables';
import css from 'styled-jsx/css';
import { useTranslation } from 'react-i18next';
import { MEDIUM, SMALL, X_SMALL } from 'lib/DeviceScreen';
import { MEDIUM_RECTANGLE } from 'lib/GoogleAds/Sizes';
import { omitUndefined } from 'lib/utils';

interface SlideshowMobileAdProps {
  adTargeting?: AdTargeting;
}

const labelCSS = css.resolve`
  .section-label {
    font-size: 12px;
    color: ${colors.G3};
  }
`;

const sectionCSS = css.resolve`
  .section {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;

function SlideshowMobileAd({ adTargeting }: SlideshowMobileAdProps): JSX.Element {
  const adTargetingFields = {
    make: adTargeting?.make,
    model: adTargeting?.model,
    year: adTargeting?.year,
    body_style: adTargeting?.type,
  };

  const { t } = useTranslation();
  return (
    <div className="ad-container" data-testid="slideshow-mobile-ad">
      <SectionHeader
        labelClassName={`section-label ${labelCSS.className}`}
        sectionClassName={`section ${sectionCSS.className}`}
      >
        {t('contentSlideshow.advertisement')}
      </SectionHeader>
      <ProximityAd
        adConfig={{
          targeting: omitUndefined({
            inLine: 1,
            ...adTargetingFields,
          }),
          dimensions: [
            [300, 250],
            [300, 300],
          ],
          screenSizes: [MEDIUM, SMALL, X_SMALL],
        }}
        placeholderSize={MEDIUM_RECTANGLE}
      />
      <SectionHeader
        labelClassName={`section-label ${labelCSS.className}`}
        sectionClassName={`section ${sectionCSS.className}`}
      >
        {t('contentSlideshow.endOfAdvertisement')}
      </SectionHeader>
      {labelCSS.styles}
      {sectionCSS.styles}
      <style jsx>{`
        .ad-container {
          margin-bottom: 24px;
        }
      `}</style>
    </div>
  );
}

export default SlideshowMobileAd;
